import $ from 'jquery';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_BASE_URL, OKTA_CLIENT_ID } from '../config';
import { validEmail } from '../lib/utilities';

let oktaConfig;
if (OKTA_BASE_URL) {
  oktaConfig = {
    issuer: `${OKTA_BASE_URL}/oauth2/default/`,
    clientId: OKTA_CLIENT_ID,
    redirectUri: `${window.location.protocol}//${window.location.host}/authorization-code/callback`,
    tokenManager: {
      storage: 'sessionStorage'
    }
  };
}

export const oktaAuthClient =
  typeof oktaConfig === 'undefined' ? null : new OktaAuth(oktaConfig);

export const requestMFA = (transaction) => {
  const { user, factors } = transaction;
  return $.ajax({
    type: 'POST',
    xhrFields: { withCredentials: true },
    url: '/wp-admin/admin-ajax.php?action=wl_request_mfa',
    data: {
      url: `/api/v1/users/${user.id}/factors/${factors[0].id}/verify`
    },
    dataType: 'json'
  });
};

const loginSuccessRedirect = (transaction, email, redirect) => {
  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=set_user',
    dataType: 'json',
    data: {
      email,
      redirect,
      sessionToken: transaction.data.sessionToken || transaction.sessionToken
    },
    success: (response) => {
      oktaAuthClient.session.setCookieAndRedirect(
        transaction.sessionToken || transaction.data.sessionToken,
        response.data.redirect_url
      );
    }
  });
};

// Primary Login
let currentTransaction; // Used to share information into MFA scope

// Recaptcha Verification
let valididRecaptcha = false;

if (oktaAuthClient && $('#account-login').length) {
  $('#account-login').on('submit', (event) => {
    event.preventDefault();

    if (!valididRecaptcha) {
      grecaptcha.reset();
      return;
    }

    $('#account-login').find(':submit').addClass('btn--loading');

    const email = $.trim($('#account-login input[name=email]').val());
    const password = $.trim($('#account-login input[name=password]').val());
    const redirect = $.trim($('#account-login input[name=redirect]').val());
    const notice = $('#account-login-notice');
    const main_site = $('#account-login').data('main-site');

    if (!main_site) {
      checkStateSiteForApprovedUser(email, password, redirect, notice, main_site);
      return;
    } else {
      notice.addClass('u--display-none');
      oktaAuthClient
        .signInWithCredentials({
          username: email,
          password: password
        })
        .then((transaction) => {
          currentTransaction = transaction;
          if (transaction.status === 'MFA_REQUIRED') {
            requestMFA(transaction).then((_) => {
              $('#account-login').hide();
              $('#mfa-verification').show();
              $('.provider-login-panel__title').text(
                'Multi-Factor Authentication'
              );
              notice.removeClass('u--display-none');
              notice
                .find('p')
                .html("A verification code has been sent to user's email");
            });
          } else if (transaction.status === 'SUCCESS') {
            notice.addClass('u--display-none');
            loginSuccessRedirect(transaction, email, redirect);
          } else {
            throw 'We cannot handle the ' + transaction.status + ' status';
          }
        })
        .catch((err) => {
          notice.removeClass('u--display-none');
          notice.find('p').html('Incorrect Username or Password. Please try again.');
          $('#account-login').find(':submit').removeClass('btn--loading');
        });
    }
  });
}

function checkStateSiteForApprovedUser(email, password, redirect, notice, main_site) {
  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=check_approved_user',
    dataType: 'json',
    data: { email: email },
    success: (response) => {
      if (response.data.approved_status === false) {
        notice.removeClass('u--display-none');
        notice.find('p').html(response.data.not_state_approved_notice);
      } else {
        notice.addClass('u--display-none');
      oktaAuthClient
        .signInWithCredentials({
          username: email,
          password: password
        })
        .then((transaction) => {
          currentTransaction = transaction;
          if (transaction.status === 'MFA_REQUIRED') {
            requestMFA(transaction).then((_) => {
              $('#account-login').hide();
              $('#mfa-verification').show();
              $('.provider-login-panel__title').text(
                'Multi-Factor Authentication'
              );
              notice.removeClass('u--display-none');
              notice
                .find('p')
                .html("A verification code has been sent to user's email");
            });
          } else if (transaction.status === 'SUCCESS') {
            notice.addClass('u--display-none');
            loginSuccessRedirect(transaction, email, redirect);
          } else {
            throw 'We cannot handle the ' + transaction.status + ' status';
          }
        })
        .catch((err) => {
          notice.removeClass('u--display-none');
          notice.find('p').html(err.message);
          $('#account-login').find(':submit').removeClass('btn--loading');
          console.error(err);
        });
      }
    }
  });
}


// Multi Factor Authentication
if (oktaAuthClient && $('#mfa-verification').length) {
  $('#mfa-verification').on('submit', (event) => {
    event.preventDefault();
    $('#mfa-verification').find(':submit').addClass('btn--loading');

    const { factors } = currentTransaction;
    const verificationCode = $.trim(
      $('#mfa-verification input[name=verification]').val()
    );
    const notice = $('#account-login-notice');
    const redirect = $.trim($('#account-login input[name=redirect]').val());
    const email = $.trim($('#account-login input[name=email]').val());

    $.ajax({
      type: 'POST',
      xhrFields: { withCredentials: true },
      url: '/wp-admin/admin-ajax.php?action=wl_authenticate_mfa',
      dataType: 'json',
      data: {
        url: `/api/v1/authn/factors/${factors[0].id}/verify`,
        passCode: verificationCode,
        stateToken: currentTransaction.data.stateToken
      },
      success: (transaction) => {
        if (transaction.data.status === 'SUCCESS') {
          loginSuccessRedirect(transaction, email, redirect);
        } else {
          notice.removeClass('u--display-none');
          notice
            .find('p')
            .html('The verification code you entered is incorrect');
          $('#mfa-verification').find(':submit').removeClass('btn--loading');
        }
      }
    }).catch((err) => {
      notice.removeClass('u--display-none');
      notice.find('p').html('The verification code you entered is incorrect');
      console.error(err);
    });
  });
}

// Forgot Password Functionality
if (oktaAuthClient && $('#lostpasswordform').length) {
  const email_input = $('#lostpasswordform input[name=user_login]');

  $('#lostpasswordform').on('submit', (event) => {
    event.preventDefault();
    const user_login = $.trim(email_input.val());

    let relayState = $('#lostpasswordform').data('relay');

    if (!relayState)
      relayState = `${window.location.protocol}//${window.location.host}/account`;

    // Setup Notice
    const notice = $('#lostpasswordform-notice');
    notice.addClass('u--display-none');

    // Check Valid Email
    if (validEmail(user_login)) {
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php?action=check_user_email',
        dataType: 'json',
        data: { email: user_login },
        success: (response) => {
          if (response.data.is_user) {
            oktaAuthClient
              .forgotPassword({
                username: user_login,
                factorType: 'EMAIL',
                relayState
              })
              .then((transaction) => {
                if (transaction.status === 'RECOVERY_CHALLENGE') {
                  notice
                    .html('Check your email for a link to reset your password.')
                    .removeClass('u--display-none');
                } else {
                  throw `We cannot handle the ${transaction.status} status`;
                }
              })
              .catch((err) => console.error(err));
          } else {
            notice
              .html(
                `We’re sorry. The email address you used does not exist in our system. Please try again with another email address or <a class="u--color-white u--font-weight-bold" href="${window.location.protocol}//${window.location.host}/account/signup/">create an account</a>.`
              )
              .removeClass('u--display-none');
          }
        },
        error: (jqXHR, exception) => {}
      });
    } else {
      notice
        .html('Please enter a valid email address.')
        .removeClass('u--display-none');
    }
  });
}

// Verify Recaptcha on page load
$(document).ready(() => {
  if ($('#account-login').length) {
    // Verify Recaptcha
    grecaptcha.ready(function() {
      grecaptcha.execute('6LcIq5YpAAAAAP1xi5q5m3pZSSPI7XXPE4XL9X_x', {action: 'submit'}).then(function(token) {
        // disable the submit button
        $('#account-login').find(':submit').prop('disabled', true);
        $('#account-login').find(':submit').addClass('btn--loading');

        $.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php?action=verify_recaptcha',
          dataType: 'json',
          data: { token },
          success: (response) => {
              if (response.success) {
                // enable the submit button
                $('#account-login').find(':submit').prop('disabled', false);
                $('#account-login').find(':submit').removeClass('btn--loading');
                valididRecaptcha = true;
              } else {
                  grecaptcha.reset();
              }
          },
          error: (error) => {
              console.log(error);
          }
        });
      });
    });
  }
});
